import React, { useEffect } from 'react';
import { SocietyDataForm } from '../../../../app/models/Society';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { BusinessName } from '../../../../app/models/BusinessName';

interface GeneralSocietyProps {
    societyForm: SocietyDataForm;
    setSocietyForm: (society: SocietyDataForm) => void;
    businessNames: BusinessName[];
    errorFields?: Record<string, string[]>;
    setErrorFields?: (errors: Record<string, string[]>) => void;
}

const SocietyForm = ({
    societyForm,
    setSocietyForm,
    businessNames,
    errorFields
}: GeneralSocietyProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        setSocietyForm({ ...societyForm, [name]: value });
    };

    if (!societyForm) return null;

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Razón Social</label>
                    <SelectTwo
                        name="business_name_id"
                        id="business_name_id"
                        inputValue={societyForm.business_name_id}
                        options={SelectTwoMapperOptions(businessNames, 'id', ['name'])}
                        hasError={fieldHasError('business_name_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('business_name_id', value?.value)}
                        placeholder={'Seleccione una razón social'}
                        onFocus={() => onFocusRemove('business_name_id')}
                        isClearable={false}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('business_name_id')}
                    </div>
                    <small className="form-text text-muted">
                        Solo se muestran las razones sociales que tienen la marca &quot;Sociedad&quot; activada.
                    </small>
                </div>
            </div>
        </>
    );
};

export default SocietyForm;
